import { createSelectorHooks } from "auto-zustand-selectors-hook";
import { produce } from "immer";
import { create } from "zustand";
import { persist, PersistStorage } from "zustand/middleware";

import { IAuthStore } from "@/types";
import {
  clearAllStorage,
  IDX_DB_VALUE_KEYS,
  indexedDbStorage,
} from "@/utils/indexDBStorage";
import deleteDatabase from "@/utils/indexedDB/deleteDatabase";
import { queryClient } from "@/pages/_app";
import { Auth } from "aws-amplify";

const useAuthStoreBase = create<IAuthStore>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      isLoading: true,
      login: async (user) => {
        await indexedDbStorage.setItem(IDX_DB_VALUE_KEYS.token, user.token);
        set(
          produce<IAuthStore>((state) => {
            state.isAuthenticated = true;
            state.user = user;
          })
        );
      },
      logout: async () => {
        await clearAllStorage();
        await queryClient.cancelQueries();
        queryClient.clear();
        await Auth.signOut();
        
        deleteDatabase("profilePicturesDB");

        set(
          produce<IAuthStore>((state) => {
            state.isAuthenticated = false;
            state.user = null;
            state.isLoading = true;
          })
        );
      },
      stopLoading: () => {
        set(
          produce<IAuthStore>((state) => {
            state.isLoading = false;
          })
        );
      },
      setAnnouncements: (announcements) => {
        set(
          produce<IAuthStore>((state) => {
            if (state.user?.bio?.announcements) {
              state.user.bio.announcements = announcements;
            }
          })
        );
      },
    }),
    {
      name: IDX_DB_VALUE_KEYS.authUserState,
      storage: indexedDbStorage as unknown as PersistStorage<unknown>,
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

const useAuthStore = createSelectorHooks(useAuthStoreBase);

export default useAuthStore;
